import React from 'react';

interface TestimonialCardProps {
  rating: number;
  title: string;
  description: string;
  name: string;
  location: string;
  avatarUrl: string;
}

const StarIcon: React.FC = () => (
  <div className="flex items-center justify-center w-8 h-8 border border-gray-200 bg-gray-50">
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path 
        d="M11.1586 1.31C11.5522 0.697163 12.4478 0.697163 12.8414 1.31L15.8804 6.04142C16.0158 6.25216 16.2255 6.40459 16.4678 6.46815L21.9068 7.89637C22.6112 8.08134 22.888 8.93311 22.4268 9.49683L18.8661 13.8492C18.7074 14.0431 18.6273 14.2896 18.6417 14.5397L18.9641 20.1539C19.0059 20.8809 18.2813 21.4074 17.6028 21.143L12.363 19.1014C12.1296 19.0105 11.8704 19.0105 11.637 19.1014L6.39726 21.143C5.71873 21.4074 4.99414 20.8809 5.03594 20.1539L5.35834 14.5397C5.37271 14.2896 5.29261 14.0431 5.13388 13.8492L1.57318 9.49683C1.11198 8.93311 1.38876 8.08134 2.09322 7.89637L7.53219 6.46815C7.77446 6.40459 7.98416 6.25216 8.11961 6.04142L11.1586 1.31Z" 
        fill="#FFE600"
      />
    </svg>
  </div>
);

export const TestimonialCard: React.FC<TestimonialCardProps> = ({
  rating,
  title,
  description,
  name,
  location,
  avatarUrl,
}) => {
  return (
    <div className="flex flex-col gap-5 p-4 md:p-5 border border-gray-200 bg-[var(--color-tertiary)]">
      {/* Star Rating */}
      <div className="flex items-start gap-1.5">
        {Array.from({ length: rating }).map((_, index) => (
          <StarIcon key={index} />
        ))}
      </div>

      {/* Content */}
      <div className="flex flex-col gap-2">
        <h3 className="text-base md:text-lg font-semibold leading-[150%] text-[var(--color-secondary)]">
          {title}
        </h3>
        <p className="text-xs md:text-sm font-normal leading-[150%] text-[var(--color-secondary)]/80">
          {description}
        </p>
      </div>

      {/* User Profile */}
      <div className="flex items-center gap-2.5">
        <div 
          className="w-[40px] h-[40px] md:w-[45px] md:h-[45px] bg-cover bg-center flex-shrink-0"
          style={{ backgroundImage: `url(${avatarUrl})` }}
        />
        <div className="flex flex-col gap-0.5 flex-1">
          <div className="text-sm md:text-base font-medium leading-[150%] text-[var(--color-secondary)]">
            {name}
          </div>
          <div className="text-xs md:text-sm font-normal leading-[150%] text-[var(--color-secondary)]/70">
            {location}
          </div>
        </div>
      </div>
    </div>
  );
};


